module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-music-08161bfc.svg";